import { useState } from 'react';

const faqs = [
  {
    q: 'When does PadelVillas go live to guests?',
    a: 'PadelVillas is live and accepting founding partner villas now. We open fully to guests once our curated collection is established. Partners who join during this founding window are guaranteed priority placement from the moment guests arrive, ahead of every other villa.',
  },
  {
    q: 'Does my villa need a padel court to be listed?',
    a: 'Yes. A private, on-site padel court is the defining feature of every property on our platform. This is not a general luxury villa site. It is purpose-built for the padel lifestyle. Your court is your unique selling point.',
  },
  {
    q: 'What commission does PadelVillas charge?',
    a: 'Founding partners benefit from zero platform commission during our entire launch period. Future standard commission rates will be clearly communicated well in advance, and founding partners will always receive preferential terms. There are no hidden fees and no charges until a guest books.',
  },
  {
    q: 'What locations are you focusing on initially?',
    a: 'Our initial focus is on Mediterranean destinations, primarily Spain, Portugal, Italy, Greece, and South of France, which align closely with the high-net-worth padel audience we are targeting. We will expand geographically as the platform grows.',
  },
  {
    q: 'How does the coach booking feature work?',
    a: 'Guests staying at listed villas can book verified local padel coaches directly through PadelVillas. Coaches are vetted for quality and professionalism, creating an elevated experience for your guests and additional visibility for your property.',
  },
  {
    q: 'What does the onboarding process involve?',
    a: 'After registering your interest, our team will review your property and reach out personally. We then work with you to create a premium villa profile, including copy review, photography guidance, and court feature highlights. We aim to make the process smooth and require as little time from you as possible.',
  },
  {
    q: 'Can I list a villa that is managed by an agency?',
    a: 'Absolutely. We welcome both owner-managed and agency-managed properties. If your villa is professionally managed, we will work with you and your management team to ensure the listing is accurate and up to date.',
  },
  {
    q: 'How long will founding partner benefits last?',
    a: 'Founding partner status is permanent. Priority placement and your founding partner badge are yours for the lifetime of your listing on PadelVillas. Zero commission applies throughout our full launch period, which we expect to run for a minimum of 12 months.',
  },
];

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section id="faq" className="py-28 bg-white">
      <div className="max-w-3xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="font-inter text-xs text-[#D4845C] uppercase tracking-[0.2em] font-medium mb-5">
            FAQ
          </p>
          <h2 className="font-cormorant text-5xl font-light text-[#2C2C2C] leading-[1.1]">
            Common Questions,<br />
            <em className="italic">Honest Answers.</em>
          </h2>
        </div>

        {/* Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div
                key={idx}
                className={`rounded-xl border transition-colors duration-200 overflow-hidden ${
                  isOpen ? 'border-[#D4845C]/30 bg-[#FAF8F5]' : 'border-gray-100 bg-[#FAF8F5]'
                }`}
              >
                <button
                  className="w-full flex items-center justify-between px-6 py-5 cursor-pointer text-left gap-4"
                  onClick={() => setOpenIdx(isOpen ? null : idx)}
                >
                  <span className="font-inter font-medium text-[#2C2C2C] text-sm leading-snug">
                    {faq.q}
                  </span>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i
                      className={`text-[#D4845C] text-lg transition-transform duration-300 ${
                        isOpen ? 'ri-subtract-line' : 'ri-add-line'
                      }`}
                    />
                  </div>
                </button>

                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="font-inter font-light text-[#6B6B6B] text-sm leading-relaxed px-6 pb-5">
                    {faq.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="font-inter font-light text-[#6B6B6B] text-sm mb-4">
            Still have questions? We&apos;d love to hear from you.
          </p>
          <a
            href="mailto:partnerships@padelvillas.vip"
            className="whitespace-nowrap font-inter text-sm font-medium text-[#D4845C] hover:underline cursor-pointer"
          >
            partnerships@padelvillas.vip
          </a>
        </div>
      </div>
    </section>
  );
}
